import { LARGE_DESKTOP_BREAKPOINT } from '../common/constants';

export const isHighResolution = () => window.innerWidth >= LARGE_DESKTOP_BREAKPOINT;
